module.exports = __webpack_public_path__ + "fonts/opensans-extrabold.9a6bf8d4.woff";